'use client'
import OtpInputBlock from '../common/OtpInputBlock'
import ActionButton from '../common/ActionButton'
import useLoginOtp from '@/hooks/useLoginOtp'

const OTPBlock = () => {
  const {
    loading,
    error,
    handleResendOTP,
    handleSubmitOTP,
    handleEditPhoneNumber,
    resetCount,
  } = useLoginOtp()

  return (
    <div>
      <OtpInputBlock
        loading={loading}
        errorMsg={error || undefined}
        onResendOTP={handleResendOTP}
        onSubmitOTP={handleSubmitOTP}
        resetCount={resetCount}
      />
      <ActionButton
        variant="secondary"
        title="Edit Phone Number"
        onClick={handleEditPhoneNumber}
        className="mb-6 text-label-lg font-semibold w-full"
      />
    </div>
  )
}

export default OTPBlock
